import { Dispatcher } from 'flux';

interface Payload {
  actionType: string;
  logLevel: 'neverlog' | 'trace' | 'debug'| 'info' | 'warn' | 'error' | 'fatal';
  [key: string]: any;
}

const AppDispatcher: Dispatcher<Payload> = new Dispatcher();

export {
  Payload
};

export default AppDispatcher;